import { StyleSheet } from 'react-native';
import colors from '@/config/colors';
import theme from '@/config/theme';

export const styles = StyleSheet.create({
  container: {
    alignSelf: 'flex-start',
    borderRadius: theme.borderRadii.lg,
    backgroundColor: colors.newUI.therapist.bgBlue10,
    borderColor: colors.newUI.therapist.blue50,
    borderWidth: 1,
    paddingVertical: theme.spacings.xs,
    paddingHorizontal: theme.spacings.sm,
    maxWidth: '100%',
  },
  label: {
    fontSize: theme.fontSizes.sm,
    color: colors.newUI.therapist.primaryBlue80,
    flexShrink: 1,
  },
  selected: {
    backgroundColor: colors.newUI.therapist.blue60,
    borderColor: colors.newUI.therapist.blue60,
  },
  hovered: {
    backgroundColor: colors.newUI.therapist.blue20,
    borderColor: colors.newUI.therapist.blue50,
  },
  hoveredSelected: {
    backgroundColor: colors.newUI.therapist.blue50,
    borderColor: colors.newUI.therapist.blue60,
  },
  labelSelected: {
    color: colors.white,
  },
});
